export const REFERRAL_TIER_REASON = {
  POST_OP_HOSPITALIZATION_CARE: 'POST_OP_HOSPITALIZATION_CARE',
  MEMBER_SECOND_OPINION: 'MEMBER_SECOND_OPINION',
  SPECIALIST_SECOND_OPINION: 'SPECIALIST_SECOND_OPINION',
  ALICE_SECOND_OPINION: 'ALICE_SECOND_OPINION',
  OTHER: 'OTHER'
}

export const REFERRAL_TIER_REASON_OPTIONS = [
  {
    value: REFERRAL_TIER_REASON.POST_OP_HOSPITALIZATION_CARE,
    label: 'Acompanhamento pós internação/pós operatório',
    isActive: true
  },
  {
    value: REFERRAL_TIER_REASON.MEMBER_SECOND_OPINION,
    label: 'Membro solicita segunda opinião técnica',
    isActive: true
  },
  {
    value: REFERRAL_TIER_REASON.SPECIALIST_SECOND_OPINION,
    label: 'Especialista solicita segunda opinião técnica',
    isActive: true
  },
  {
    value: REFERRAL_TIER_REASON.ALICE_SECOND_OPINION,
    label: 'Alice solicita segunda opinião técnica',
    isActive: true
  },
  {
    value: REFERRAL_TIER_REASON.OTHER,
    label: 'Outros',
    isActive: true
  }
]
